import PlanCard from '../PlanCard';

import { Variant } from '../../types';

import styles from './styles.module.scss';

interface PlanCardConfig {
  name: string;
  variant?: Variant;
}

interface LoadingProps {
  cards?: PlanCardConfig[];
}

const Loading = ({ cards }: LoadingProps) => {
  const fallbackCard: PlanCardConfig = { name: '-', variant: undefined };
  const cardsToRender = cards && cards.length > 0 ? cards : [fallbackCard];

  return (
    <>
      {cardsToRender.map((card, index) => (
        <PlanCard key={index} name={card.name} variant={card.variant}>
          <div className={styles['loadingCharacteristics']} />
          <div className={styles['loadingButton']} />
          <div className={styles['loadingPrice']} />
          <div className={styles['loadingLabel']} />
        </PlanCard>
      ))}
    </>
  );
};

export default Loading;
